import { GET_DIALSHREE_LEADS, GET_DIALSHREE_LEADS_LOADING, GETDIALSHREE_LEADS_FAILD } from '../type/type';

const initialState = {
    allLeadsData: {
        docs: [],
        totalDocs: 0,
        limit: 0,
        page: 0,
        totalPages: 0,
        pagingCounter: 0,
        hasPrevPage: false,
        hasNextPage: false,
        prevPage: null,
        nextPage: null,
        selectedLeads: [],
    },
    allLeadsLoading: true,
    loading: false,
}

const DialShreeleadsReducer = (state = initialState, action) => {
    const { type, payload } = action
    switch (type) {
        case GET_DIALSHREE_LEADS_LOADING:
            return { ...state, loading: true };
        case GET_DIALSHREE_LEADS:
            return {
                ...state,
                allLeadsData: {
                    ...state.allLeadsData, // Keep existing structure
                    ...payload, // Update with new API response data
                    page: payload.page || state.allLeadsData.page, // Ensure the page updates correctly
                },
                allLeadsLoading: false,
                loading: false
            };
        case GETDIALSHREE_LEADS_FAILD:
            return {
                ...state,
                loading: false,
                allLeadsLoading: false,
            };
        // case GET_OLA_LEADS:
        //   return { ...state, allLeadsData: payload, allLeadsLoading: false, };
        default:
            return state
    }
}

export default DialShreeleadsReducer;  
